import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// export var addUserRes;
export const addUserTodo = createAsyncThunk('addUser', async (data) => {
    try {
        const formData = new FormData();
        formData.append('name', data.user_name);
        formData.append('email', data.email);
        formData.append('phone', data.phone_no);
        formData.append('password', data.password);
        formData.append('confirmPassword', data.confirm_password);
        formData.append('userRole', data.role || 'staff'); // static if not provided
        formData.append('designation_id', data.designation);
        formData.append('department_id', data.department);
        formData.append('status', data.status || 'Active');
        formData.append('path', data.path || 'category');
        if (data.profile_image) {
            formData.append('profile_image', data.profile_image);
        }

        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'user',
            data: formData,
            headers: { "Content-Type": "multipart/form-data", "Authorization": 'Bearer ' + localStorage.getItem('token') }
        })
        return res
        //  ={
        //    status: res,
        //     // data: res.data
        // };

    } catch (error) {
        return error.response
        // = error.response.data
    }
})




